import { Box, Card, CardContent, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

const IpTracker = () => {

    const [systemData,setSystemData] = useState([])
    const [loading,setLoading] = useState(true)
    const [error,setError] = useState('')

    useEffect(()=>{
        const fetchItems = async()=>{
            try{
                const res = await fetch('https://ipwhois.app/json/')
                const data = await res.json()
                setSystemData(data)
            }catch(err){
                setError(`Error in fetching : ${err.message}`)
            }finally{
                setLoading(false)
            }
        }
        fetchItems();
    },[])

    if(loading){
        return <Typography variant='h6' sx={{display:'flex',justifyContent:'center',alignItems:'center',height:'89vh'}}>Loading...</Typography>
    }

    if(error){
        return <Typography variant='h6' sx={{display:'flex',color:'red',justifyContent:'center',alignItems:'center',height:'89vh'}}>Error : {error}</Typography>
    }

  return (
    <Box sx={{display:'flex',justifyContent:'center',alignItems:'center',height:'82vh',py:3,px:3}}>
    <Card elevation={5}>
        <CardContent >
            <Typography variant='h6' sx={{fontWeight:'bold'}}>IP Address Tracker App</Typography>
            <Typography sx={{mt:2}}>IP : {systemData.ip}</Typography>
            <Typography sx={{mt:2}}>COUNTRY : {systemData.country}</Typography>
            <Typography sx={{mt:2}}>CITY : {systemData.city}</Typography>
            <Typography sx={{mt:2}}>ISP : {systemData.isp}</Typography>
            <Typography sx={{mt:2}}>TimeZone : {systemData.timezone}</Typography>               
        </CardContent>
    </Card>
    </Box>
  )
}

export default IpTracker